import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { EAdvancedFilterType } from '../../models/advanced-filter-type.enum';
import { TAdvancedFilterSingle, TSearchFilterRow } from '../../models/advanced-filter.model';
import { TSearchAdvancedFilterOperator } from '../../../points/point-search/point-search.consts';
import { EWorkspaces } from '../../../workspace/workspaces.enum';
import { checkCustomWorkspaceId } from '../../../workspace/workspace';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventAdvancedFilter,
  EGoogleEventCategory,
} from 'src/app/project/services/analytics/google-analytics.consts';

@Component({
  selector: 'pp-advanced-filters-row',
  templateUrl: './advanced-filters-row.component.html',
  styleUrls: ['./advanced-filters-row.component.scss'],
  standalone: false,
})
export class AdvancedFiltersRowComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Input() ppAdvancedFilter?: TSearchFilterRow;

  @Input() ppWorkspaceId: string;
  @Input() ppIndex: number;
  @Input() ppLogic: TSearchAdvancedFilterOperator;

  EIconPath = EIconPath;
  buttonHovered = false;
  isOverview = false;
  isTimeline = false;

  @Output() ppDeleteFilter = new EventEmitter<void>();
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();
  @Output() ppLogicChange = new EventEmitter<TSearchAdvancedFilterOperator>();

  EAdvancedFilterType = EAdvancedFilterType;

  constructor() {
    this.isOverview = checkCustomWorkspaceId() === EWorkspaces.OVERVIEW;
    this.isTimeline = checkCustomWorkspaceId() === EWorkspaces.TIMELINE;
  }

  deleteFilter(): void {
    this.ppDeleteFilter.emit();
  }

  changeField(): void {
    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }

  changeLogic(newLogic: TSearchAdvancedFilterOperator): void {
    this.ppLogicChange.emit(newLogic);
    this.applyChanges();
  }

  changeFilterType(newFilter: TAdvancedFilterSingle): void {
    this.ppFilter = {
      ...newFilter,
      option: null,
      value: null,
    };

    this.ppAdvancedFilter = {
      ...this.ppAdvancedFilter,
      item: {
        ...this.ppAdvancedFilter?.item,
      },
      keys: newFilter.customFields?.length ? newFilter.customFields : [newFilter.id],
    };

    const advancedFilterEvent = EGoogleEventAdvancedFilter?.[this.ppFilter.type];

    if (advancedFilterEvent) {
      logEventInGTAG(advancedFilterEvent, {
        source: EGoogleEventCategory.ADVANCED_FILTER,
      });
    }

    this.applyChanges();
  }

  buttonHover(isHovered: boolean): void {
    this.buttonHovered = isHovered;
  }
}
